import type { CSSProperties } from 'react';

export interface ToggleProps {
  checked?: boolean;
  onChange?: (next: boolean) => void;
  label?: string;
  description?: string;
  disabled?: boolean;
}

export function Toggle({ checked = false, onChange, label, description, disabled = false }: ToggleProps) {
  const knob: CSSProperties = {
    position: 'absolute',
    top: 2,
    width: 16,
    height: 16,
    borderRadius: '50%',
    background: '#fff',
    transition: 'left .15s cubic-bezier(.22,.61,.36,1)',
    left: checked ? 16 : 2,
  };
  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.45 : 1,
        fontFamily: 'var(--font-body)',
      }}
    >
      {(label || description) && (
        <span style={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
          {label && <span style={{ fontSize: 12.5, fontWeight: 500, color: 'var(--text-1)' }}>{label}</span>}
          {description && <span style={{ fontSize: 10.5, color: 'var(--text-3)' }}>{description}</span>}
        </span>
      )}
      <span
        onClick={disabled ? undefined : () => onChange && onChange(!checked)}
        style={{
          position: 'relative',
          width: 34,
          height: 20,
          borderRadius: 11,
          flexShrink: 0,
          background: checked ? 'var(--primary)' : 'var(--surface-3)',
          border: '1px solid ' + (checked ? 'transparent' : 'var(--line-strong)'),
          transition: 'none',
        }}
      >
        <i style={knob} />
      </span>
    </label>
  );
}
